// // import React, { useState, useCallback } from "react";
// // import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// // import { Link, useLocation } from "react-router-dom";

// // export default function Header1() {
// //   const [menuOpen, setMenuOpen] = useState(false);
// //   const [dropdownOpen, setDropdownOpen] = useState(false);
// //   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
// //   const location = useLocation();

// //   const navLinks = [
// //     { name: "Home", path: "/home" },
// //     { name: "About-Us", path: "/about" },
// //     { name: "Services", path: "/services" },
// //     { name: "Technology", path: "/technology" },
// //     { name: "Contact-Us", path: "/contact" },
// //   ];

// //   const serviceLinks = [
// //     { name: "Web Development", path: "/web" },
// //     { name: "Mobile App Development", path: "/mob" },
// //     { name: "E-Commerce Solutions", path: "/ecom" },
// //     { name: "Salesforce ", path: "salesforce" },
// //     { name: "ServiceNow", path: "/contact" },
// //     { name: "Staff Augmentation", path: "/staff" },
// //   ];

// //   // ✅ Optimized hover behavior
// //   const handleHover = useCallback(
// //     (state) => {
// //       setDropdownOpen(state);
// //     },
// //     [setDropdownOpen]
// //   );

// //   return (
// //   <header className="fixed top-0 w-full z-50 bg-gradient-to-r from-black via-[#0A0A0A] to-black shadow-[0_2px_10px_rgba(212,175,55,0.15)] transition-all duration-300 border-b border-[#D4AF37]/20">
// //     <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">
      
// //       {/* === LOGO === */}
// //       <Link to="/" className="flex items-center gap-2 group">
// //         <img
// //           src="/logo.png"
// //           alt="Codex Logo"
// //           className="w-9 h-9 sm:w-10 sm:h-10 transition-transform duration-300 group-hover:scale-105 drop-shadow-[0_0_4px_rgba(212,175,55,0.4)]"
// //           loading="lazy"
// //         />
// //         <span className="text-lg sm:text-xl md:text-2xl font-extrabold whitespace-nowrap">
// //           <span className="text-white">Codex </span>
// //           <span className="text-white">Future </span>
// //           <span className="text-white">Technologies</span>
// //         </span>
// //       </Link>

// //       {/* === DESKTOP NAVIGATION === */}
// //       <nav className="hidden md:flex gap-6 lg:gap-8 items-center relative">
// //         {navLinks.map((link) =>
// //           link.name === "Services" ? (
// //             <div
// //               key={link.name}
// //               className="relative"
// //               onMouseEnter={() => handleHover(true)}
// //               onMouseLeave={() => handleHover(false)}
// //             >
// //               <button
// //                 className={`flex items-center gap-1 font-semibold relative transition-all duration-300 
// //                   ${
// //                     location.pathname === "/services"
// //                       ? "text-[#D4AF37] after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[2px] after:bg-[#D4AF37]"
// //                       : "text-gray-200 hover:text-[#D4AF37]"
// //                   }`}
// //               >
// //                 {link.name}
// //                 <FiChevronDown
// //                   className={`mt-[1px] transition-transform duration-300 ${
// //                     dropdownOpen ? "rotate-180 text-[#D4AF37]" : ""
// //                   }`}
// //                 />
// //               </button>

// //               {/* Dropdown */}
// //               <div
// //                 className={`absolute left-0 mt-2 w-56 bg-black/90 border border-[#D4AF37]/40 rounded-xl shadow-xl py-2 z-50 transform-gpu transition-all duration-300 backdrop-blur-xl ${
// //                   dropdownOpen
// //                     ? "opacity-100 translate-y-0 visible"
// //                     : "opacity-0 translate-y-2 invisible"
// //                 }`}
// //               >
// //                 {serviceLinks.map((service) => (
// //                   <Link
// //                     key={service.name}
// //                     to={service.path}
// //                     className="block px-4 py-2 text-gray-300 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] transition-all duration-200"
// //                   >
// //                     {service.name}
// //                   </Link>
// //                 ))}
// //               </div>
// //             </div>
// //           ) : (
// //             <Link
// //               key={link.name}
// //               to={link.path}
// //               className={`relative font-semibold transition-all duration-300 
// //                 ${
// //                   location.pathname === link.path
// //                     ? "text-[#D4AF37] after:content-[''] after:absolute after:left-0 after:bottom-[-4px] after:w-full after:h-[2px] after:bg-[#D4AF37]"
// //                     : "text-gray-200 hover:text-[#D4AF37]"
// //                 }`}
// //             >
// //               {link.name}
// //             </Link>
// //           )
// //         )}
// //       </nav>

// //       {/* === MOBILE MENU BUTTON === */}
// //       <button
// //         onClick={() => setMenuOpen((prev) => !prev)}
// //         className="md:hidden text-gray-200 focus:outline-none transition-transform active:scale-90"
// //         aria-label="Toggle Menu"
// //       >
// //         {menuOpen ? (
// //           <FiX size={26} className="text-[#D4AF37]" />
// //         ) : (
// //           <FiMenu size={26} className="text-[#D4AF37]" />
// //         )}
// //       </button>
// //     </div>

// //     {/* === MOBILE MENU === */}
// //     <div
// //       className={`md:hidden absolute top-full left-0 w-full bg-black/95 border-t border-[#D4AF37]/20 backdrop-blur-md transform transition-all duration-300 ease-in-out ${
// //         menuOpen
// //           ? "translate-y-0 opacity-100 visible"
// //           : "-translate-y-5 opacity-0 invisible"
// //       }`}
// //     >
// //       <div className="flex flex-col items-center py-4 gap-3 sm:gap-4">
// //         {navLinks.map((link) =>
// //           link.name === "Services" ? (
// //             <div key={link.name} className="w-full text-center">
// //               <button
// //                 onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
// //                 className="flex items-center justify-center gap-1 text-gray-200 text-base sm:text-lg font-semibold hover:text-[#D4AF37] transition-all"
// //               >
// //                 {link.name}
// //                 <FiChevronDown
// //                   className={`transform transition-transform duration-300 ${
// //                     mobileDropdownOpen ? "rotate-180 text-[#D4AF37]" : ""
// //                   }`}
// //                 />
// //               </button>

// //               {/* Mobile Dropdown */}
// //               <div
// //                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
// //                   mobileDropdownOpen
// //                     ? "max-h-96 opacity-100 mt-2"
// //                     : "max-h-0 opacity-0"
// //                 }`}
// //               >
// //                 {serviceLinks.map((service) => (
// //                   <Link
// //                     key={service.name}
// //                     to={service.path}
// //                     onClick={() => setMenuOpen(false)}
// //                     className="block py-2 text-gray-300 text-sm sm:text-base hover:text-[#D4AF37] transition-colors duration-200"
// //                   >
// //                     {service.name}
// //                   </Link>
// //                 ))}
// //               </div>
// //             </div>
// //           ) : (
// //             <Link
// //               key={link.name}
// //               to={link.path}
// //               onClick={() => setMenuOpen(false)}
// //               className={`text-base sm:text-lg font-semibold transition-all duration-300 ${
// //                 location.pathname === link.path
// //                   ? "text-[#D4AF37] underline underline-offset-4"
// //                   : "text-gray-300 hover:text-[#D4AF37]"
// //               }`}
// //             >
// //               {link.name}
// //             </Link>
// //           )
// //         )}
// //       </div>
// //     </div>
// //   </header>
// // );

// // }



// import React, { useState, useCallback } from "react"; 
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Header1() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   return (
//     <header className="
//       fixed top-0 w-full z-50 
//       bg-gradient-to-r from-black via-[#0A0A0A] to-black
//       shadow-[0_2px_10px_rgba(212,175,55,0.25)]
//       border-b border-[#D4AF37]/25
//       transition-all duration-300
//     ">
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">

//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Logo"
//             className="w-10 h-10 transition-transform duration-300 group-hover:scale-110 drop-shadow-[0_0_5px_rgba(212,175,55,0.4)]"
//           />
//           <span className="text-xl md:text-2xl font-extrabold text-white">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex gap-7 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold text-white transition-all duration-300
//                     ${
//                       location.pathname === "/services"
//                         ? "text-[#D4AF37]"
//                         : "hover:text-[#D4AF37]"
//                     }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#D4AF37]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* DROPDOWN */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 
//                     bg-black/95 backdrop-blur-xl
//                     border border-[#D4AF37]/40 
//                     rounded-xl shadow-xl py-2
//                     transition-all duration-300 z-50
//                     ${
//                       dropdownOpen
//                         ? "opacity-100 translate-y-0 visible"
//                         : "opacity-0 translate-y-2 invisible"
//                     }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-gray-300 hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all rounded-md"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold transition-all duration-300 relative
//                   ${
//                     location.pathname === link.path
//                       ? "text-[#D4AF37]"
//                       : "text-white hover:text-[#D4AF37]"
//                   }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </nav>

//         {/* MOBILE MENU BUTTON */}
//         <button
//           onClick={() => setMenuOpen(!menuOpen)}
//           className="md:hidden text-[#D4AF37] transition-transform active:scale-90"
//         >
//           {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
//         </button>
//       </div>

//       {/* MOBILE MENU */}
//       <div
//         className={`md:hidden absolute top-full left-0 w-full 
//           bg-black/95 backdrop-blur-xl border-t border-[#D4AF37]/30 transition-all duration-300
//           ${menuOpen ? "translate-y-0 opacity-100" : "-translate-y-5 opacity-0 invisible"}
//         `}
//       >
//         <div className="flex flex-col items-center py-4 gap-3">

//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div key={link.name} className="w-full text-center">
//                 <button
//                   onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
//                   className="w-full flex items-center justify-center gap-2 text-white text-lg font-semibold hover:text-[#D4AF37]"
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-all ${
//                       mobileDropdownOpen ? "rotate-180 text-[#D4AF37]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 <div
//                   className={`transition-all overflow-hidden
//                     ${mobileDropdownOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}
//                   `}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       onClick={() => setMenuOpen(false)}
//                       className="block py-2 text-gray-300 hover:text-[#D4AF37] transition-all"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 onClick={() => setMenuOpen(false)}
//                 className={`text-lg font-semibold py-2 transition-all
//                   ${location.pathname === link.path ? "text-[#D4AF37]" : "text-white hover:text-[#D4AF37]"}
//                 `}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }



// import React, { useState, useCallback } from "react";
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Header1({ handleToggle }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   return (
//     <header
//       className="
//       fixed top-0 w-full z-50 
//       bg-gradient-to-r from-black via-[#0A0A0A] to-black
//       shadow-[0_2px_10px_rgba(212,175,55,0.25)]
//       border-b border-[#D4AF37]/25
//       transition-all duration-300
//     "
//     >
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">

//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Logo"
//             className="w-10 h-10 transition-transform duration-300 group-hover:scale-110 drop-shadow-[0_0_5px_rgba(212,175,55,0.4)]"
//           />
//           <span className="text-xl md:text-2xl font-extrabold text-white">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex gap-7 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold text-white transition-all duration-300
//                     ${
//                       location.pathname === "/services"
//                         ? "text-[#D4AF37]"
//                         : "hover:text-[#D4AF37]"
//                     }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#D4AF37]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* DROPDOWN */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 
//                     bg-black/95 backdrop-blur-xl
//                     border border-[#D4AF37]/40 
//                     rounded-xl shadow-xl py-2
//                     transition-all duration-300 z-50
//                     ${
//                       dropdownOpen
//                         ? "opacity-100 translate-y-0 visible"
//                         : "opacity-0 translate-y-2 invisible"
//                     }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-gray-300 hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all rounded-md"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold transition-all duration-300 relative
//                   ${
//                     location.pathname === link.path
//                       ? "text-[#D4AF37]"
//                       : "text-white hover:text-[#D4AF37]"
//                   }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}

//           {/* 🔥 THEME TOGGLE BUTTON */}
//           <button
//             onClick={handleToggle}
//             className="ml-4 border border-[#D4AF37] text-[#D4AF37] px-3 py-1 rounded-lg hover:bg-[#D4AF37] hover:text-black transition-all"
//           >
//             Switch
//           </button>
//         </nav>

//         {/* MOBILE MENU BUTTON */}
//         <button
//           onClick={() => setMenuOpen(!menuOpen)}
//           className="md:hidden text-[#D4AF37] transition-transform active:scale-90"
//         >
//           {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
//         </button>

//         {/* 🔥 MOBILE TOGGLE BUTTON */}
//         <button
//           onClick={handleToggle}
//           className="md:hidden ml-3 border border-[#D4AF37] text-[#D4AF37] px-3 py-1 rounded-lg"
//         >
//           Switch
//         </button>
//       </div>
//     </header>
//   );
// }


// import React, { useState, useCallback } from "react";
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Header1({ handleToggle }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   return (
//     <header
//       className="
//       fixed top-0 w-full z-50 
//       bg-gradient-to-r from-black via-[#0A0A0A] to-black
//       shadow-[0_2px_10px_rgba(212,175,55,0.25)]
//       border-b border-[#D4AF37]/25
//       transition-all duration-300
//     "
//     >
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">
//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Logo"
//             className="w-10 h-10 transition-transform duration-300 group-hover:scale-110 drop-shadow-[0_0_5px_rgba(212,175,55,0.4)]"
//           />
//           <span className="text-lg sm:text-xl md:text-2xl font-extrabold text-white whitespace-nowrap">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex gap-7 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold text-white transition-all duration-300
//                     ${
//                       location.pathname === "/services"
//                         ? "text-[#D4AF37]"
//                         : "hover:text-[#D4AF37]"
//                     }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#D4AF37]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* Desktop Dropdown */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 
//                     bg-black/95 backdrop-blur-xl
//                     border border-[#D4AF37]/40 
//                     rounded-xl shadow-xl py-2
//                     transition-all duration-300 z-50
//                     ${
//                       dropdownOpen
//                         ? "opacity-100 translate-y-0 visible"
//                         : "opacity-0 translate-y-2 invisible"
//                     }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-gray-300 hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all rounded-md"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold transition-all duration-300 relative
//                   ${
//                     location.pathname === link.path
//                       ? "text-[#D4AF37]"
//                       : "text-white hover:text-[#D4AF37]"
//                   }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}

//           {/* THEME TOGGLE */}
//           <button
//             onClick={handleToggle}
//             className="ml-4 border border-[#D4AF37] text-[#D4AF37] px-3 py-1 rounded-lg hover:bg-[#D4AF37] hover:text-black transition-all"
//           >
//             Switch
//           </button>
//         </nav>

//         {/* MOBILE MENU BUTTON */}
//         <div className="flex items-center gap-3 md:hidden">
//           <button
//             onClick={() => setMenuOpen(!menuOpen)}
//             className="text-[#D4AF37] transition-transform active:scale-90"
//           >
//             {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
//           </button>

//           {/* MOBILE SWITCH */}
//           <button
//             onClick={handleToggle}
//             className="border border-[#D4AF37] text-[#D4AF37] px-3 py-1 rounded-lg"
//           >
//             Switch
//           </button>
//         </div>
//       </div>

//       {/* MOBILE DROPDOWN MENU */}
//       {menuOpen && (
//         <div
//           className="md:hidden bg-black/95 backdrop-blur-xl border-t border-[#D4AF37]/30 shadow-xl px-6 py-4 space-y-3"
//         >
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div key={link.name} className="text-white">
//                 <button
//                   onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
//                   className="w-full flex justify-between items-center px-2 py-2 font-semibold text-left"
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform ${
//                       mobileDropdownOpen ? "rotate-180 text-[#D4AF37]" : ""
//                     }`}
//                   />
//                 </button>

//                 {/* MOBILE SERVICE LIST */}
//                 {mobileDropdownOpen && (
//                   <div className="pl-4 space-y-2">
//                     {serviceLinks.map((service) => (
//                       <Link
//                         key={service.name}
//                         to={service.path}
//                         onClick={() => setMenuOpen(false)}
//                         className="block text-gray-300 hover:text-[#D4AF37] transition"
//                       >
//                         {service.name}
//                       </Link>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 onClick={() => setMenuOpen(false)}
//                 className="block text-white font-semibold px-2 py-2"
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </div>
//       )}
//     </header>
//   );
// }



import React, { useState, useCallback } from "react";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

export default function Header1({ handleToggle }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/home" },
    { name: "About-Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Technology", path: "/technology" },
    { name: "Contact-Us", path: "/contact" },
  ];

  const serviceLinks = [
    { name: "Web Development", path: "/web" },
    { name: "Mobile App Development", path: "/mob" },
    { name: "E-Commerce Solutions", path: "/ecom" },
    { name: "Salesforce", path: "/salesforce" },
    { name: "ServiceNow", path: "/contact" },
    { name: "Staff Augmentation", path: "/staff" },
  ];

  const handleHover = useCallback((state) => {
    setDropdownOpen(state);
  }, []);

  return (
    <header
      className="
      fixed top-0 w-full z-50 
      bg-gradient-to-r from-black via-[#0A0A0A] to-black
      shadow-[0_2px_10px_rgba(212,175,55,0.25)]
      border-b border-[#D4AF37]/25
      transition-all duration-300
    "
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">

        {/* LOGO */}
        <Link to="/" className="flex items-center gap-2 group">
          <img
            src="/logo.png"
            alt="Logo"
            className="w-10 h-10 transition-transform duration-300 group-hover:scale-110 drop-shadow-[0_0_5px_rgba(212,175,55,0.4)]"
          />
          <span className="text-lg sm:text-xl md:text-2xl font-extrabold text-white whitespace-nowrap">
            Codex Future Technologies
          </span>
        </Link>

        {/* DESKTOP MENU */}
        <nav className="hidden md:flex gap-7 items-center relative">
          {navLinks.map((link) =>
            link.name === "Services" ? (
              <div
                key={link.name}
                className="relative"
                onMouseEnter={() => handleHover(true)}
                onMouseLeave={() => handleHover(false)}
              >
                <button
                  className={`flex items-center gap-1 font-semibold text-white transition-all duration-300
                    ${
                      location.pathname === "/services"
                        ? "text-[#D4AF37]"
                        : "hover:text-[#D4AF37]"
                    }`}
                >
                  {link.name}
                  <FiChevronDown
                    className={`transition-transform duration-300 ${
                      dropdownOpen ? "rotate-180 text-[#D4AF37]" : "text-white"
                    }`}
                  />
                </button>

                {/* Desktop Dropdown */}
                <div
                  className={`absolute left-0 mt-2 w-56 
                    bg-black/95 backdrop-blur-xl
                    border border-[#D4AF37]/40 
                    rounded-xl shadow-xl py-2
                    transition-all duration-300 z-50
                    ${
                      dropdownOpen
                        ? "opacity-100 translate-y-0 visible"
                        : "opacity-0 translate-y-2 invisible"
                    }`}
                >
                  {serviceLinks.map((service) => (
                    <Link
                      key={service.name}
                      to={service.path}
                      className="block px-4 py-2 text-gray-300 hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all rounded-md"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                key={link.name}
                to={link.path}
                className={`font-semibold transition-all duration-300 relative
                  ${
                    location.pathname === link.path
                      ? "text-[#D4AF37]"
                      : "text-white hover:text-[#D4AF37]"
                  }`}
              >
                {link.name}
              </Link>
            )
          )}

          {/* THEME TOGGLE */}
          <button
            onClick={handleToggle}
            className="ml-4 border border-[#D4AF37] text-[#D4AF37] px-3 py-1 rounded-lg hover:bg-[#D4AF37] hover:text-black transition-all"
          >
            Switch
          </button>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-[#D4AF37] transition-transform active:scale-90"
        >
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {/* MOBILE DROPDOWN MENU */}
      {menuOpen && (
        <div
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-[#D4AF37]/30 shadow-xl px-6 py-4 space-y-3"
        >
          {navLinks.map((link) =>
            link.name === "Services" ? (
              <div key={link.name} className="text-white">
                <button
                  onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                  className="w-full flex justify-between items-center px-2 py-2 font-semibold text-left"
                >
                  {link.name}
                  <FiChevronDown
                    className={`transition-transform ${
                      mobileDropdownOpen ? "rotate-180 text-[#D4AF37]" : ""
                    }`}
                  />
                </button>

                {/* MOBILE SERVICE LIST */}
                {mobileDropdownOpen && (
                  <div className="pl-4 space-y-2">
                    {serviceLinks.map((service) => (
                      <Link
                        key={service.name}
                        to={service.path}
                        onClick={() => setMenuOpen(false)}
                        className="block text-gray-300 hover:text-[#D4AF37] transition"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className="block text-white font-semibold px-2 py-2"
              >
                {link.name}
              </Link>
            )
          )}

          {/* ✅ MOBILE SWITCH BUTTON INSIDE THE MENU */}
          <button
            onClick={() => {
              handleToggle();
              setMenuOpen(false);
            }}
            className="w-full mt-2 border border-[#D4AF37] text-[#D4AF37] px-4 py-2 rounded-lg text-center font-semibold hover:bg-[#D4AF37] hover:text-black transition-all"
          >
            Switch Theme
          </button>
        </div>
      )}
    </header>
  );
}
